<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :supervisionData="supervisionData" :isUncompleted="true" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/supervision/List";
import { mapState } from "vuex";

export default {
  components: {
    List,
  },
  computed: {
    ...mapState("SuperVision", ["supervisionData"]),
  },
  methods: {},
  created() {
    this.$store.dispatch("SuperVision/getUncompletedList", {
      ids: JSON.parse(this.$route.query.values),
    });
  },
};
</script>
